import type { InsertThirdPartyContactApiMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertThirdPartyContactApiDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Mirrors the legacy action arguments. `UserId` / `PasswordSetAtTimestamp` are
 * absent by design — the tRPC service resolves them from Auth0.
 */
export interface InsertThirdPartyContactInput {
  ThirdPartyId: string;
  Email: string;
  Name?: string;
  JobTitle?: string;
}

/**
 * `insertThirdPartyContactApi` (COI-170). Folded onto `createMutationHook`
 * because the data-layer processor uses `NoOpEventStrategy`, so the tRPC
 * service is a plain call — no `executeAsyncRequest`, no twin needed.
 */
export const useInsertThirdPartyContact = createMutationHook({
  name: 'insertThirdPartyContact',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.thirdPartyContact.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertThirdPartyContactInput) => input,
  mapResponse: (result: {
    Id: string;
  }): InsertThirdPartyContactApiMutation => ({
    insertThirdPartyContactApi: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  // Apollo parity: evictField(cache, 'third_party_contact')
  invalidate: (trpc) => [trpc.frontend.thirdPartyContact.pathKey()],
  graphqlDocument: InsertThirdPartyContactApiDocument,
  graphqlVariables: (input) => ({ ...input }),
  evictFields: ['third_party_contact'],
});
